module.exports = __webpack_public_path__ + "static/img/1958_05_15_TownHallProgram_5.d584bf5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cage/archive/1958_05_15_TownHallProgram_5.jpg
// module id = Hmit
// module chunks = 0